import { render } from "./DeletedPermissionsList.vue?vue&type=template&id=1a567057"
import script from "./DeletedPermissionsList.vue?vue&type=script&lang=js"
export * from "./DeletedPermissionsList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__